import { DriveFileRenameOutline, Folder } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ShowList__ShowFolder } from '../../queries/queries.generated';

export interface ShowMenuShowFolderProps {
  /** Set by the menu when this is its first child; this component has no element to take it. */
  autoFocus?: boolean;
  item: ShowList__ShowFolder;
  onMove: () => void;
  onRename: () => void;
}

export const ShowMenuShowFolder = ({
  autoFocus,
  item,
  onMove,
  onRename,
}: ShowMenuShowFolderProps) => {
  const { t } = useTranslation();
  return (
    <>
      <MenuItem autoFocus={autoFocus} disabled={!item.canUpdate.value} onClick={onMove}>
        <ListItemIcon>
          <Folder />
        </ListItemIcon>
        <ListItemText>{t('pages.shows.menu.move_folder')}</ListItemText>
      </MenuItem>
      <MenuItem disabled={!item.canUpdate.value} onClick={onRename}>
        <ListItemIcon>
          <DriveFileRenameOutline />
        </ListItemIcon>
        <ListItemText>{t('pages.shows.menu.rename_folder')}</ListItemText>
      </MenuItem>
    </>
  );
};
